import { useState, type FormEvent, type JSX } from 'react';

import { api } from '../lib/api';

/**
 * Sprememba naziva podjetja (samo skrbnik).
 *
 * Naziv je tisto, po cemer stranka prepozna svoje podjetje v porocilih in
 * vabilih, zato mora biti popravljiv brez posega v bazo. Vir se ne spreminja:
 * dolocajo ga uvozene knjizbe.
 */
export function PreimenujPodjetje({
  podjetje,
  naziv,
  naSpremembo,
}: {
  podjetje: string;
  naziv: string;
  naSpremembo: (naziv: string) => void;
}): JSX.Element {
  const [vnos, setVnos] = useState(naziv);
  const [shranjuje, setShranjuje] = useState(false);
  const [sporocilo, setSporocilo] = useState<string | null>(null);
  const [napaka, setNapaka] = useState<string | null>(null);

  const shrani = (dogodek: FormEvent): void => {
    dogodek.preventDefault();
    const nov = vnos.trim();
    if (nov === '' || nov === naziv) return;
    setShranjuje(true);
    setSporocilo(null);
    setNapaka(null);
    api
      .preimenujPodjetje(podjetje, nov)
      .then((posodobljeno) => {
        naSpremembo(posodobljeno.naziv);
        setVnos(posodobljeno.naziv);
        setSporocilo('Naziv je shranjen.');
      })
      .catch((e: unknown) => {
        setNapaka(e instanceof Error ? e.message : 'Naziva ni bilo mogoče shraniti.');
      })
      .finally(() => {
        setShranjuje(false);
      });
  };

  return (
    <section className="kartica">
      <h2>Naziv podjetja</h2>
      <form onSubmit={shrani} className="obrazec">
        <label>
          Naziv
          <input
            type="text"
            value={vnos}
            maxLength={200}
            onChange={(d) => {
              setVnos(d.target.value);
              setSporocilo(null);
            }}
            required
          />
        </label>
        <button type="submit" disabled={shranjuje || vnos.trim() === '' || vnos.trim() === naziv}>
          {shranjuje ? 'Shranjujem …' : 'Shrani naziv'}
        </button>
      </form>
      <p className="namig">
        Naziv vidijo stranke v poročilih in vabilih. Sprememba se zapiše v dnevnik dejanj.
      </p>
      {sporocilo !== null && <p className="drobno">{sporocilo}</p>}
      {napaka !== null && <p className="napaka">{napaka}</p>}
    </section>
  );
}
